<template>
  <div>
    <h3 class="display-4" @click="enableDebug($event)">Maintenance Extras</h3>

    <o-list-toolbar
      :filters-list="filter_list"
      :search-fields-list="search_field_list"
      :selected-filter="selected_filter"
      :list-options="list_options"
      @reset_table="reset_table"
      @options_changed="update_table($event)"
      @filter_changed="update_filter($event)"
      :schema="schema"
      :query-select-options="options"
    >
      <template slot="middle">
        <!-- <b-form-select
          v-model="select_date_to_update"
          class="w-20 h-a"
          :options="filter_date_list"
          options-field="None"
          text-field="name"
          value-field="code"
        />
        <div class="w-20">
          <b-form-datepicker
            v-model="set_date_update"
            id="datepicker-dateformat2"
            :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
            }"
            locale="en"
          ></b-form-datepicker>
        </div>

        <b-button
          variant="primary"
          class="w-10"
          :disabled="checkIfNotEmpty"
          @click="updateDateNow()"
          >Set</b-button
        > -->
      </template>
    </o-list-toolbar>

    <b-table
      striped
      bordered
      :fields="fields"
      :items="items"
      head-variant="light"
      class="o-list maint"
      thead-class="o-gradient-header position-sticky"
      sticky-header="70vh"
      no-local-sorting
      @sort-changed="change_sort"
      :sort-by="list_options.sort"
      :sort-desc="list_options.order === 'desc'"
      :tbody-tr-class="rowClass"
    >
      <!-- <template v-slot:head(is_checked)="data">
        <input v-model="toogleAll" @click="toogleAllSelected" type="checkbox" />
      </template> -->
      <!-- <template slot="cell(is_checked)" slot-scope="{ index, item }">
        <input
          v-model="item.is_checked"
          @click="toogleSelected(item)"
          type="checkbox"
        />
      </template> -->
      <template v-slot:cell(_selected)="{ rowSelected }">
        <template v-if="rowSelected">
          <span aria-hidden="true">&check;</span>
          <span class="sr-only">Selected</span>
        </template>
        <template v-else>
          <span aria-hidden="true">&nbsp;</span>
          <span class="sr-only">Not selected</span>
        </template>
      </template>
      <template slot="cell(id)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'id'"
        >
          <default-display :value="item.id"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(active_end_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'active_end_date'"
        >
          <date-display
            :value="item.active_end_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(active_start_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'active_start_date'"
        >
          <date-display
            :value="item.active_start_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(amount)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'amount'"
        >
          <label v-if="item.quoted_amount">$</label>
          <number-display
            :value="getIncGSTAmount(item.quoted_amount)"
            :decimals="2"
          />
        </o-link-cell>
      </template>
      <template slot="cell(quoted_amount)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'amount'"
        >
          <label v-if="item.quoted_amount">$</label>
          <number-display :value="item.quoted_amount" :decimals="2" />
        </o-link-cell>
      </template>
      <template slot="cell(builder)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'builder'"
        >
          <lookup-display
            :list="optionCustomerItemsById"
            :value="item.builder"
            display-field="name"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(cancelled_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'cancelled_date'"
        >
          <date-display
            :value="item.cancelled_date"
            format="DD/MM/YYYY"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(code)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'code'"
          style="color: inherit; text-decoration: underline"
        >
          <default-display :value="item.code"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(completed_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'completed_date'"
        >
          <date-display
            :value="item.completed_date"
            format="DD/MM/YYYY"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(created_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'created_date'"
        >
          <date-display
            :value="item.created_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(date_raised_quoted)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'date_raised_quoted'"
        >
          <date-display
            :value="item.date_raised_quoted"
            format="DD/MM/YYYY"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(description)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'description'"
        >
          <default-display :value="item.description"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(invoices)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'invoices'"
        >
          <p v-for="invoice in item.invoices">
            {{ invoice["invoice_number"] }}
          </p>
        </o-link-cell>
      </template>
      <template slot="cell(invoice_no)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'invoices'"
        >
          <p v-for="invoice in item.invoices">
            {{ invoice["invoice_number"] }}
          </p>
        </o-link-cell>
      </template>
      <template slot="cell(date_invoiced)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'invoices'"
        >
          <date-display
            v-for="(invoice, index) in item.invoices"
            :key="index"
            :value="invoice.date_invoiced"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(purchase_orders)" slot-scope="{ index, item }">
        <o-link-cell
          v-if="item.purchase_orders"
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'purchase_orders'"
        >
          <!-- index == item.purchase_orders.length - 1
                    ? purchase_order.date_po_supplied
                    : purchase_order.date_po_supplied + ', '
                    <date-display
                      :key="index"
                      :value="convertDate"
                      format="DD/MM/YYYY"
                    ></date-display>
            -->
          <template v-for="(purchase_order, index) in item.purchase_orders">
            <div :key="index">
              <default-display
                :value="
                  item.purchase_orders.length > 0 && item.purchase_orders
                    ? index == item.purchase_orders.length - 1
                      ? convertDate(purchase_order.date_po_supplied)
                      : convertDate(purchase_order.date_po_supplied) + '\n'
                    : 'None'
                "
              ></default-display>
            </div>
          </template>
        </o-link-cell>
      </template>
      <template slot="cell(invoice_paid)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'invoices'"
        >
          <p v-for="invoice in item.invoices">
            {{ invoice["paid"] == true ? "Yes" : "No" }}
          </p>
        </o-link-cell>
      </template>
      <template slot="cell(job)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'job'"
        >
          <default-display :value="item.job"></default-display>
        </o-link-cell>
      </template>
      <template
        slot="cell(maintenance_order_number)"
        slot-scope="{ index, item }"
      >
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'maintenance_order_number'"
        >
          <default-display
            :value="item.maintenance_order_number"
          ></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(modified_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'modified_date'"
        >
          <date-display
            :value="item.modified_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(old_job_no)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'old_job_no'"
        >
          <default-display :value="item.old_job_no"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(purchase_order_number)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'purchase_order_number'"
        >
          <template v-for="(purchase_order, index) in item.purchase_orders">
            <div :key="index">
              <default-display
                :key="index"
                :value="
                  item.purchase_orders.length > 0 && item.purchase_orders
                    ? index == item.purchase_orders.length - 1
                      ? getPONumber(purchase_order.po_number)
                      : getPONumber(purchase_order.po_number) + '\n'
                    : 'None'
                "
              ></default-display>
            </div>
          </template>
          <!-- <default-display
            :value="item.purchase_order_number"
          ></default-display> -->
        </o-link-cell>
      </template>
      <template slot="cell(repair_files)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'repair_files'"
        >
          <default-display :value="item.repair_files"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(repair_notes)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'repair_notes'"
        >
          <default-display :value="item.repair_notes"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(site_address)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'site_address'"
        >
          <default-display :value="item.site_address"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(suburb)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'suburb'"
        >
          <default-display :value="item.suburb"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(supervisor)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'supervisor'"
        >
          <default-display :value="item.supervisor_name"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(supervisor_name)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'supervisor_name'"
        >
          <default-display :value="item.supervisor_name"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(used_materials)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'used_materials'"
        >
          <default-display :value="item.used_materials"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(audit_trail)" slot-scope="{ index, item }">
        <a
          :href="
            'https://shojun3.qa2.ocom.com.au/static/services.html#/service_extra/history?extraId=' +
            item.id
          "
          target="_blank"
          rel="noopener noreferrer"
          >View</a
        >
        <!-- <o-link-cell
          :to="{
            name: 'service_repair.history',
            params: { repairId: item.id, code: item.code },
          }"
        >
          <default-display value="View"></default-display>
        </o-link-cell> -->
        <!-- <o-link-cell
          :to="{
            name: 'service_repair.history',
            params: { repairId: item.id, code: item.code },
          }"
        >
          <default-display value="View"></default-display>
        </o-link-cell> -->
      </template>

      <template slot="cell(raised_by)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'raised_by'"
        >
          <lookup-display
            :list="optionEmployeeItemsById"
            :value="item.raised_by"
            display-field="full_name"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(entered_by)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'entered_by'"
        >
          <template v-for="(purchase_order, index) in item.purchase_orders">
            <div :key="index">
              <default-display
                :key="index"
                :value="
                  item.purchase_orders.length > 0 && item.purchase_orders
                    ? index == item.purchase_orders.length - 1
                      ? getSuppliedByName(purchase_order.po_supplied_by)
                      : getSuppliedByName(purchase_order.po_supplied_by) + '\n'
                    : 'None'
                "
              ></default-display>
            </div>
          </template>
          <!-- <default-display :value="item.entered_by__username"></default-display> -->
        </o-link-cell>
      </template>
      <template slot="cell(date_raised)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'date_raised'"
        >
          <date-display
            :value="item.date_raised"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(extra_type)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'extra_type'"
        >
          <default-display
            :value="item.extra_type__description"
          ></default-display>
          <!-- <lookup-display
            :list="optionCodeExtraTypeItemsById"
            :value="item.extra_type"
            display-field="description"
            default-value="-"
          ></lookup-display> -->
        </o-link-cell>
      </template>
      <template slot="cell(sub_contractor)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'sub_contractor'"
        >
          <!-- <lookup-display
            :list="optionCodeSubContractorItemsById"
            :value="item.sub_contractor"
            display-field="description"
            default-value="-"
          ></lookup-display> -->
        </o-link-cell>
      </template>
      <template
        slot="cell(sub_contractor_invoice_amount)"
        slot-scope="{ index, item }"
      >
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'sub_contractor_invoice_amount'"
        >
          <number-display
            :value="item.sub_contractor_invoice_amount"
            :decimals="2"
          />
        </o-link-cell>
      </template>
      <template slot="cell(customer)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'customer'"
        >
          <default-display :value="item.customer"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(date_po_requested)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'date_po_requested'"
        >
          <date-display
            :value="item.date_po_requested"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(over_due_po)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'over_due_po'"
        >
          <number-display :value="item.over_due_po" :decimals="0" />
        </o-link-cell>
      </template>
      <template slot="cell(comments)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_extra.edit', params: { id: item.id } }"
          :when="first_column_key === 'comments'"
        >
          <default-display :value="item.comments"></default-display>
        </o-link-cell>
      </template>
      <template slot="empty">
        <p>
          <emoticon-sad-icon large></emoticon-sad-icon>
        </p>
        No Data Found. Please
        <router-link :to="{ name: 'service_extra.create' }"
          >create a new item</router-link
        >
      </template>
    </b-table>

    <o-list-paging
      :limit="list_options.limit"
      :page-options="rows_per_page_items"
      :offset="list_options.offset"
      :total-items="total_items"
      @change-limit="change_limit"
      @change-page="change_page"
    />
  </div>
</template>

<style></style>

<script>
import { mapActions, mapMutations } from "vuex";
import {
  CreateCodeTableFetchMixin,
  CreateGroupPermissionMixin,
  CreateListPageMixin,
  MultiActionsMixin,
} from "../../../vue-ocom/mixins";
import {
  fieldToTableColumn,
  GetSearchFields,
} from "../../../vue-ocom/schema/schema_utils";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import schema from "../../schema/index";

import OListToolbar from "../../../vue-ocom/components/list/OListToolbar";
import OListPaging from "../../../vue-ocom/components/list/OListPaging";
import DefaultDisplay from "../../../vue-ocom/components/display/DefaultDisplay";
import DateDisplay from "../../../vue-ocom/components/display/DateDisplay";
import NumberDisplay from "../../../vue-ocom/components/display/NumberDisplay";
import BooleanDisplay from "../../../vue-ocom/components/display/BooleanDisplay";
import LookupDisplay from "../../../vue-ocom/components/display/LookupDisplay";
import EmoticonSadIcon from "vue-material-design-icons/EmoticonSad";
import ODateTime from "../../../vue-ocom/components/forms/fields/ODateTime";
import OFormWrapper from "../../../vue-ocom/components/forms/OFormWrapper";

import OWidgetWrapper from "../../../vue-ocom/components/forms/OWidgetWrapper";
import EmailIcon from "vue-material-design-icons/Email";
import LinkIcon from "vue-material-design-icons/Link";
import moment from "moment";

export default {
  components: {
    OFormWrapper,
    OWidgetWrapper,
    ODateTime,
    EmoticonSadIcon,
    EmailIcon,
    LinkIcon,
    OListPaging,
    OListToolbar,
    DateDisplay,
    DefaultDisplay,
    BooleanDisplay,
    NumberDisplay,
    LookupDisplay,
  },
  mixins: [
    CreateListPageMixin("ServiceExtra", "service_extra", "po_received"),
    MultiActionsMixin,
    CreateGroupPermissionMixin("ServiceExtra"),
    CreateCodeTableFetchMixin(["Customer", "Supervisor", "Employee"]),
  ],
  data: function () {
    return {
      date_quoted: "date_quoted",
      date_po_supplied: "date_po_supplied",
      completed_date: "completed_date",
      select_date_to_update: null,
      set_date_update: new Date(),
      update_date: [],
      default_date: new Date(),
      toogleAll: false,
      schemaModel: cleanUpModel(
        schema.ServiceExtra,
        {}
      ) /*Use this.schema instead */,

      search_field_list: GetSearchFields(schema.ServiceExtra),

      filterRow: true /* Set to False to disable filter row */,
      filter_date_list: [
        { name: "Date Quoted", code: "date_quoted" },
        { name: "Date PO Supplied", code: "date_po_supplied" },
        { name: "Completed Date", code: "completed_date" },
      ],
      filter_list: [
        {
          name: "Active (PO Received)",
          code: "po_received_maint",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "Quote Required",
          code: "quote_required_maint",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "Quoted",
          code: "quoted_maint",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "Completed",
          code: "completed_maint",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "Cancelled",
          code: "cancelled_maint",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "All",
          code: "all_maintenance",
          options: { offset: 0, sort: "id" },
        },
      ],

      user_column_selection: null /* If user can customise the columns set them here */,
      column_override_params: {
        /* Put any column overrides here key by fieldname */
        id: { label: "Extra No" },
        code: { label: "Extra Ref No" },
        purchase_order_number: { label: "PO No." },
        job: { label: "Job Number" },
        entered_by: { label: "PO No. Supplied By" },
        completed_date: { label: "Completed Date" },
        amount: { label: "Quoted Amount (Inc GST)" },
        purchase_orders: { label: "Date PO Supplied" },
      },
    };
  },
  methods: {
    ...mapMutations(["showMessage"]),
    ...mapActions("ServiceExtraModule", ["patchItem"]),
    getPONumber(ponumber) {
      if (ponumber) {
        return ponumber;
      }
      return "None";
    },
    getSuppliedByName(name) {
      if (name) {
        return name;
      }

      return "None";
    },
    convertDate(date) {
      if (date) {
        let conDate = moment(date).format("DD/MM/YYYY");
        return conDate;
      }

      return "None";
    },

    getIncGSTAmount(amount) {
      let gstAmount = amount * 1.1;
      return gstAmount;
    },
    checkPoNumber(orderNumber) {
      let haveOrder = false;
      orderNumber.forEach((order) => {
        if (order.po_number) {
          haveOrder = true;
        }
      });
      return haveOrder;
    },
    checkDataValid(date) {
      var valid = new Date(date).getTime() > 0;
      // console.log('data', date+" "+valid+" "+data item.invoices.length)
      return valid;
    },
    checkDataInvalid(date) {
      var valid = new Date(date).getTime() > 0;
      //   console.log('date'+valid);
      // console.log('data', date+" "+valid+" "+data item.invoices.length)
      return !valid;
    },
    addTdClass(entries) {
      entries.forEach(function (entry) {
        if (entry) {
          entry["tdClass"] = "cell_style";
        }
      });
    },
    cell_style(value, key, item) {
      if (key === "quoted_amount" || key === "amount") {
        return "text-right";
      }
      return null;
    },

    rowClass(item, type) {
      return "tr-" + item.maint_service_status;
    },
    // updateDateNow() {
    //   this.update_date.forEach((element) => {
    //     let payload;
    //     this.set_date_update = moment(new Date(this.set_date_update)).format(
    //       "YYYY-MM-DD"
    //     );
    //     if (this.select_date_to_update == this.date_quoted) {
    //       payload = {
    //         id: element.id,
    //         date_raised_quoted: this.set_date_update,
    //       };
    //     } else if (this.select_date_to_update == this.date_po_supplied) {
    //       payload = {
    //         id: element.id,
    //         date_po_supplied: this.set_date_update,
    //       };
    //     } else if (this.select_date_to_update == this.completed_date) {
    //       payload = {
    //         id: element.id,
    //         completed_date: this.set_date_update,
    //       };
    //     } else {
    //       // nothing else to do
    //     }

    //     this.patchItem(payload)
    //       .then(() => {
    //         this.showMessage({
    //           message: "Update success",
    //           type: "success",
    //           show: true,
    //         });
    //       })
    //       .catch(() => {
    //         this.showMessage({
    //           message: "Request Failed",
    //           type: "danger",
    //           show: true,
    //         });
    //       });
    //   });
    //   this.update_date = [];
    // },
    // pushItem(item) {
    //   if (item.is_checked) {
    //     // push the elements to the data store
    //     this.update_date.push(item);
    //   } else {
    //     // remove the elements to the data store
    //     this.update_date.splice(this.update_date.indexOf(item), 1);
    //   }
    //   // alert(item.is_checked)
    // },
    // toogleSelected(item) {
    //   item.is_checked = !item.is_checked;
    //   this.pushItem(item);
    // },
    // toogleAllSelected() {
    //   this.items.forEach((element) => {
    //     element.is_checked = !this.toogleAll;
    //     this.pushItem(element);
    //   });
    //   // console.log('this.update_date',this.update_date);
    // },
  },

  computed: {
    checkIfNotEmpty() {
      if (
        this.select_date_to_update &&
        this.set_date_update &&
        this.update_date.length > 0
      ) {
        return false;
      }
      return true;
    },
    checkListOptions() {
      return this.list_options.filter;
    },
    options() {
      return {
        Customer: {
          options: this.optionCustomerItems,
          textField: "name",
          valueField: "id",
        },
        Supervisor: {
          options: this.optionSupervisorItems,
          textField: "name",
          valueField: "id",
        },
        Job: {
          options: this.optionJobItems,
          textField: "description",
          valueField: "id",
        },
      };
    },
    fields() {
      const vm = this;
      const selectedColumns = this.user_column_selection || [
        "code",
        "date_raised_quoted",
        "extra_type",
        "supervisor",
        "purchase_order_number",
        "job__id",
        "builder",
        "site_address",
        "suburb",
        "description",
        "quoted_amount",
        "amount",

        "raised_by",
        "entered_by",
        "purchase_orders",
        "comments",
        "completed_date",
        "code",
      ];
      const fields = selectedColumns.map(function (item) {
        return fieldToTableColumn(
          vm.schema,
          item,
          vm.column_override_params[item]
        );
      });
      this.addTdClass(this.filterTableColumns(this.schema, fields));

      return this.addSelectionColums(
        this.filterTableColumns(this.schema, fields)
      );
    },
    first_column_key() {
      if (this.fields) {
        return this.fields[0].key;
      } else {
        return null;
      }
    },
  },
};
</script>

<style>
.h-a {
  height: auto;
}
.w-20 {
  width: 15% !important;
  margin-left: 20px;
}
.w-10 {
  margin-left: 20px;
}
.maint .tr-unknown {
  background-color: white;
}
.maint .tr-quoted-required {
  background-color: lightyellow !important;
}
.maint .tr-quoted {
  background-color: lightyellow !important;
}
.maint .tr-po-received {
  background-color: lightgreen !important;
  color: black;
}
.maint .tr-cancelled {
  background-color: salmon !important;
  color: black;
}
.maint .tr-completed {
  background-color: #ddd !important;
  color: black;
}
ul {
  align-items: center;
}
div.maint > table.table-bordered > thead > tr > th {
  border: 1px solid #888989 !important;
}
div.maint > table.table-bordered > tbody > tr > td {
  border: 1px solid #888989;
}
</style>
